import { useEffect, useState } from "react";

import { useFormContext } from "react-hook-form";

import Grid from "@mui/material/Grid";

import { useAuth } from "../../authentication";
import { PermissionEnum } from "../../permissions";
import { statusLabels } from "../../shared";
import { formatMoney } from "../../shared/utils";
import { CustomTable } from "../../ui";

const ProductVariantsSection = () => {
  const { hasPermission } = useAuth();
  const { watch } = useFormContext();
  const productVariants = watch("productVariants");
  const [productVariantPaginate, setProductVariantPaginate] = useState({
    currentPage: 0,
    size: 10,
    totalItems: productVariants.length,
  });

  useEffect(() => {
    setProductVariantPaginate((prev) => ({
      ...prev,
      totalItems: productVariants.length,
    }));
  }, [productVariants]);

  const columns = [
    {
      field: "sku",
      headerName: "SKU",
    },
    {
      field: "name",
      headerName: "Name",
    },
    {
      field: "status",
      headerName: "Status",
      renderCell: ({ status }) => statusLabels[status],
    },
  ];

  if (hasPermission(PermissionEnum.UPDATE_PRODUCT_RETAIL_PRICE)) {
    columns.push({
      field: "retailPrice",
      headerName: "Harga Retail (Rp)",
      align: "right",
      renderCell: ({ retailPrice }) =>
        formatMoney(retailPrice, {
          withCurrency: false,
        }),
    });
  }

  if (hasPermission(PermissionEnum.UPDATE_PRODUCT_DISTRIBUTOR_PRICE)) {
    columns.push({
      field: "distributorPrice",
      headerName: "Harga Distributor (Rp)",
      align: "right",
      renderCell: ({ distributorPrice }) =>
        formatMoney(distributorPrice, {
          withCurrency: false,
        }),
    });
  }

  return (
    productVariants.length > 0 && (
      <Grid size={{ xs: 12 }}>
        <CustomTable
          keyField="sku"
          columns={columns}
          rows={productVariants.slice(
            productVariantPaginate.currentPage * productVariantPaginate.size,
            (productVariantPaginate.currentPage + 1) *
              productVariantPaginate.size
          )}
          pageInfo={productVariantPaginate}
          onPageChange={(page) =>
            setProductVariantPaginate({
              ...productVariantPaginate,
              currentPage: page,
            })
          }
          onRowsPerPageChange={(pageSize) =>
            setProductVariantPaginate({
              ...productVariantPaginate,
              size: pageSize,
              currentPage: 0,
            })
          }
        />
      </Grid>
    )
  );
};

export default ProductVariantsSection;
